// src/components/GameListName/GameListName.tsx
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import classes from './GameListName.module.less';
import { getActiveList } from '../../views/auth/slice/selectors';
import { getGameGroup } from '../../constants/Games';

// Nazwa aktywnej listy w lewym górnym rogu ekranu gry — naprzeciw przycisku „⋯”, w stylu licznika pozycji.
// Poza grami jej nie ma
const GameListName: FC = () => {
  const { pathname } = useLocation();
  const activeList = useSelector(getActiveList);

  if (!getGameGroup(pathname) || !activeList?.name) {
    return null;
  }

  return <p className={classes.name}>{activeList.name}</p>;
};

export default GameListName;
